// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';

$w.onReady(function () 
{




});

/*
export function generateVoucherButton_click(event) {
// Create voucher ID
    let voucherID = Math.random()*25131232513;
    voucherID = Math.floor(voucherID);
    //voucherID = voucherID.toString();
    //console.log(voucherID.type);

// Create voucher expiration date - today + 90 days
    let dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + 90);
    let voucherExpirationDate = dateNow;

// Activate voucher
    let voucherStatus = true;
// Input data from text boxes saved in array 
    let toSave = {
      "Customer Name": $w('#customerNameInput').value,
      "Voucher From": $w('#voucherFromInput').value,
      "Package Description": $w('#packageDescriptionInput').value,
      "Voucher ID": voucherID.toString(),
      "Expiration Date": voucherExpirationDate,
      "Voucher Status": voucherStatus
      //"Voucher Value": "₪"+$w('#voucherValue').value
    };
//Save input data to DB
    wixData.save("Vouchers", toSave);
} */
 
/*
export function voucherDropdown_change(event) {
	//Add your code for this event here: 
   // console.log($w('#voucherDropdown').value);
    let packageDescription = wixData.get("Vouchers", "45");
    //let packageDescription = wixData.query("Vouchers").find('45');
    console.log(packageDescription);
    console.log($w("#dataset1").getCurrentItem());

} */


export function generateVoucherNoGreetingButton_click(event) {
// Create voucher ID
    let voucherID = Math.random()*25131232513;
    voucherID = Math.floor(voucherID);
    //voucherID = voucherID.toString();
    //console.log(voucherID.type);

// Create voucher expiration date - today + 90 days
    let dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + 90);
    let voucherExpirationDate = dateNow;

// Activate voucher
    let voucherStatus = true;
// Input data from text boxes saved in array 
    let toSave = {
      "Customer Name": $w('#customerNameInput').value,
      "Voucher From": $w('#voucherFromInput').value,
      "Package Description": $w('#packageDescriptionInput').value,
      "Voucher ID": voucherID.toString(),
      "Expiration Date": voucherExpirationDate,
      "Voucher Status": voucherStatus
    };
//Save input data to DB
    wixData.save("Vouchers", toSave);
}

export function generateVoucherWithGreetingButton_click(event) {
// Create voucher ID
    let voucherID = Math.random()*25131232513;
    voucherID = Math.floor(voucherID);
    //voucherID = voucherID.toString();
    //console.log(voucherID.type);

// Create voucher expiration date - today + 90 days
    let dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + 90);
    let voucherExpirationDate = dateNow;

// Activate voucher
    let voucherStatus = true;
// Input data from text boxes saved in array 
    let toSave = {
      "Customer Name": $w('#customerNameInput').value,
      "Voucher From": $w('#voucherFromInput').value,
      "Package Description": $w('#packageDescriptionInput').value,
      "Voucher ID": voucherID.toString(),
      "Expiration Date": voucherExpirationDate,
      "Voucher Status": voucherStatus,
      "Greeting": $w('#greetingsInput').value
    };
//Save input data to DB
    wixData.save("Vouchers", toSave);
}


export function generateVoucherEnglishButton_click(event) {
	// Create voucher ID
    let voucherID = Math.random()*25131232513;
    voucherID = Math.floor(voucherID);
    //voucherID = voucherID.toString();
    //console.log(voucherID.type);

// Create voucher expiration date - today + 90 days
    let dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + 90);
    let voucherExpirationDate = dateNow;

// Activate voucher
    let voucherStatus = true;
// Input data from text boxes saved in array 
    let toSave = {
      "Customer Name": $w('#customerNameInput').value,
      "Voucher From": $w('#voucherFromInput').value,
      "Package Description": $w('#packageDescriptionInput').value,
      "Voucher ID": voucherID.toString(),
      "Expiration Date": voucherExpirationDate,
      "Voucher Status": voucherStatus
    };
//Save input data to DB
    wixData.save("Vouchers", toSave);
}


export function generateVoucherCosmeticsButton_click(event) {
	// Create voucher ID
    let voucherID = Math.random()*25131232513;
    voucherID = Math.floor(voucherID);
    //voucherID = voucherID.toString();
    //console.log(voucherID.type);

// Create voucher expiration date - today + 90 days
    let dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + 90);
    let voucherExpirationDate = dateNow;

// Activate voucher
    let voucherStatus = true;
// Input data from text boxes saved in array 
    let toSave = {
      "Customer Name": $w('#customerNameInput').value,
      "Voucher From": $w('#voucherFromInput').value,
      "Package Description": $w('#packageDescriptionInput').value,
      "Voucher ID": voucherID.toString(),
      "Expiration Date": voucherExpirationDate,
      "Voucher Status": voucherStatus    };
//Save input data to DB
    wixData.save("Vouchers", toSave);
}

export function calculateTotal(parameter) {
    let voucherSpaCompoundPrice = Number($w('#voucherSpaCompoundPriceInput').value);
    let voucherServicePrice = Number($w('#voucherServicePriceInput').value);
    let totalPrice = voucherSpaCompoundPrice + voucherServicePrice;

    $w('#voucherTotalPrice').value = totalPrice.toString();
}

export function voucherServicePriceInput_change(event) {
	calculateTotal();
}

export function voucherSpaCompoundPriceInput_change(event) {
	calculateTotal();
}
/*
export function spaProductSelectorDropdown_change(event) {
//    $w('#packageDescriptionInput').value = $w('#spaProductSelectorDropdown').value;
    //let getDropdownValue = $w('#dataset4').setFilter(wixData.filter().eq("Spa Products",$w('#spaProductSelectorDropdown').value));
    let getDropdownValue;
    getDropdownValue = wixData.query("spaProducts").hasAll("Title", $w('#spaProductSelectorDropdown').value);
    console.log(getDropdownValue);    
    
  //  $w('#packageDescriptionInput').value = getDropdownValue;


} */

export function voucherServicePriceInput_keyPress(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}